import { setCountAction } from "../search/_common.js";

const main = () => {
    if (document.querySelector('#page-sold') === null) return;
    document.querySelector('.pg__search__type select').addEventListener('change', (e) => {
        e.currentTarget.closest('form').submit();
    });
    setCountAction();
}

export default main;